import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-dt/css/dataTables.dataTables.css";
import axios from "axios";
import { createMRTColumnHelper } from "material-react-table";
import { Box, Button, Chip } from "@mui/material";
import { useSelector } from "react-redux";
import { baseUrl } from "../../../helper/urls";
import { ToastContainer, toast } from "react-toastify";
import AdminExpandTable from "../../../components/custom_table/AdminExpandTable";
import Swal from "sweetalert2"; // ✅ Import SweetAlert2

const Payment = () => {
  const { token } = useSelector((state) => state.auth);
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);

  // const formatDateToLocalYYYYMMDD = (date) => {
  //   if (!date) return "";
  //   const d = new Date(date);
  //   const day = String(d.getDate()).padStart(2, "0");
  //   const month = String(d.getMonth() + 1).padStart(2, "0");
  //   const year = d.getFullYear();
  //   return `${year}-${month}-${day}`;
  // };

  const fetchStudents = async (startDateParam = null, endDateParam = null) => {
    try {
      const params = new URLSearchParams();

      // if (startDateParam) {
      //   params.append("startDate", formatDateToLocalYYYYMMDD(startDateParam));
      // }
      // if (endDateParam) {
      //   params.append("endDate", formatDateToLocalYYYYMMDD(endDateParam));
      // }

      const queryString = params.toString();
      const apiUrl = queryString
        ? `${baseUrl}/bookings/getPaymentList?${queryString}`
        : `${baseUrl}/bookings/getPaymentList`;

      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.get(apiUrl, { headers });

      setStudents(response.data.data || []);
      setLoading(false);
      setTimeout(() => {
        $("#dataTable").DataTable({
          pageLength: 5,
          destroy: true,
        });
      }, 100);
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };

  // const handleDateFilter = () => {
  //   setLoading(true);
  //   fetchStudents(startDate, endDate);
  // };

  // const handleClearFilter = () => {
  //   setStartDate(null);
  //   setEndDate(null);
  //   setLoading(true);
  //   fetchStudents();
  // };

  useEffect(() => {
    fetchStudents();

    return () => {
      if ($.fn.DataTable.isDataTable("#dataTable")) {
        $("#dataTable").DataTable().destroy(true);
      }
    };
  }, []);

  const handlePay = async (rowData) => {
    const url = `${baseUrl}/bookings/payout/${rowData.counselorId}`;

    const validTxns =
      rowData.txn?.filter((item) => item.summary !== null) || [];

    const bookedIds = validTxns.map((item) => item.bookingId);

    const payload = {
      bookedIds,
      amount: rowData.payout_amount,
    };

    if (bookedIds.length === 0) {
      toast.warn("No valid bookings to pay.");
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.post(url, payload, { headers });
      if (response.data.success === true) {
        toast.success(response.data.message);
        fetchStudents(); // Refresh table
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Payment error:", error);
      toast.error("Payment failed!");
    }
  };

  // ✅ SweetAlert2 wrapper
  const confirmAndPay = (rowData) => {
    Swal.fire({
      html: `<div style="font-size: 30px; font-weight: bold;">Are you sure?</div>`,
      text: `You’re about to pay $${rowData.payout_amount} to ${rowData.c_firstName} ${rowData.c_lastName}.`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, pay",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handlePay(rowData);
      }
    });
  };

  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("firstName", {
      header: "Counselor Name",
      size: 30,
      Cell: (cell) =>
        cell.row.original?.c_firstName + " " + cell.row.original?.c_lastName,
    }),
    columnHelper.accessor("payout_amount", {
      header: "Payout Amount ($)",
      size: 30,
    }),
    columnHelper.accessor("bank", {
      header: "Bank",
      size: 30,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return (
          <Chip
            label={value === 0 ? "No" : "Yes"}
            color={value === 0 ? "error" : "success"}
            size="small"
          />
        );
      },
    }),
    columnHelper.accessor("payout_count", {
      header: "Payout Count",
      size: 30,
    }),
    columnHelper.accessor("pending_summary_count", {
      header: "Pending Summary",
      size: 30,
    }),
    columnHelper.accessor("unPayout_amount", {
      header: "Pending Amount ($)",
      size: 30,
    }),
  ];

  columns.unshift(
    columnHelper.accessor("Actions", {
      header: "Actions",
      size: 30,
      Cell: ({ cell }) => {
        const rowData = cell.row.original; // current row’s data
        const isBankMissing = rowData.bank === 0;

        return (
          <Button
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#124178", color: "white" }}
            onClick={() => confirmAndPay(rowData)}
            disabled={isBankMissing} // ✅ disable when bank === 0
          >
            Pay Now
          </Button>
        );
      },
    })
  );

  // const styles = {
  //   container: {
  //     display: "flex",
  //     flexWrap: "wrap",
  //     gap: "12px",
  //     padding: "16px",
  //     background: "#fff",
  //     borderRadius: "8px",
  //     marginBottom: "20px",
  //     alignItems: "flex-end",
  //   },
  //   group: {
  //     display: "flex",
  //     flexDirection: "column",
  //     gap: "4px",
  //   },
  //   label: {
  //     fontSize: "14px",
  //     fontWeight: 500,
  //     color: "#333",
  //   },
  //   input: {
  //     padding: "6px 10px",
  //     fontSize: "14px",
  //     height: "36px",
  //     border: "1px solid #ccc",
  //     borderRadius: "6px",
  //     minWidth: "180px",
  //   },
  //   iconButton: {
  //     width: "36px",
  //     height: "36px",
  //     border: "none",
  //     borderRadius: "50%",
  //     cursor: "pointer",
  //     display: "flex",
  //     alignItems: "center",
  //     justifyContent: "center",
  //     fontSize: "18px",
  //     transition: "0.2s ease-in-out",
  //   },
  //   primary: {
  //     backgroundColor: "#e3f2fd",
  //     color: "#1976d2",
  //   },
  //   primaryHover: {
  //     backgroundColor: "#bbdefb",
  //   },
  //   secondary: {
  //     backgroundColor: "#fce4ec",
  //     color: "#d32f2f",
  //   },
  //   secondaryHover: {
  //     backgroundColor: "#f8bbd0",
  //   },
  // };

  return (
    <>
      <ToastContainer />
      {/* <div style={styles.container}>
        <div style={styles.group}>
          <label style={styles.label}>Start Date</label>
          <input
            type="date"
            value={startDate}
            max={endDate || ""}
            onChange={(e) => setStartDate(e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.group}>
          <label style={styles.label}>End Date</label>
          <input
            type="date"
            value={endDate}
            min={startDate || ""}
            onChange={(e) => setEndDate(e.target.value)}
            style={styles.input}
          />
        </div>

        <button
          style={{ ...styles.iconButton, ...styles.primary }}
          onClick={handleDateFilter}
          disabled={loading}
          title="Apply Filter"
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor =
              styles.primaryHover.backgroundColor;
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor =
              styles.primary.backgroundColor;
          }}
        >
          <Icon icon="material-symbols:search" />
        </button>

        <button
          style={{ ...styles.iconButton, ...styles.secondary }}
          onClick={handleClearFilter}
          disabled={loading}
          title="Clear Filter"
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor =
              styles.secondaryHover.backgroundColor;
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor =
              styles.secondary.backgroundColor;
          }}
        >
          <Icon icon="material-symbols:cancel-outline-rounded" />
        </button>
      </div> */}

      <AdminExpandTable
        columns={columns}
        data={students}
        enableExpanding
        loading={loading}
      />
    </>
  );
};

export default Payment;
